export default __webpack_public_path__ + "static/12-677fba85d41108e6a42975e605930306.jpg";